import jwtDecode from 'jwt-decode';

// Dono da busca que a galeria guarda na loja do Volto.
//
// A loja vive até a aba fechar e uma busca não sabe de quem é: o reducer
// recria a chave quando a resposta chega, mesmo depois de a chave ter sido
// zerada, então uma resposta atrasada da conta A pode reaparecer quando a
// conta B abre a mesma página. Por isso o dono entra na CHAVE: o que A buscou
// fica numa chave que B nunca lê.
//
// O dono é o usuário (o `sub` do JWT, como o App.jsx do core), não o token: o
// Volto renova o token sozinho e a renovação não muda de usuário. A conta fica
// aqui, e não num módulo compartilhado, para o bloco ser o mesmo arquivo no
// portal e na intranet.
export const ANONIMO = 'anon';

export function donoDaSessao(token) {
  if (!token) return ANONIMO;
  try {
    const usuario = jwtDecode(token).sub;
    if (!usuario) return token;
    // um usuário com o id "anon" não pode dividir chave com o anônimo
    return usuario === ANONIMO ? `u:${usuario}` : usuario;
  } catch (erro) {
    // Token que não é JWT vale por ele mesmo: nunca divide chave com outro.
    return token;
  }
}

// O caminho entra na chave porque uma página copiada leva os mesmos ids de
// bloco: sem ele, a resposta atrasada de uma cópia cairia na outra.
export const chaveDaGaleria = (bloco, caminho, dono) =>
  `agsusGaleria_${bloco || 'bloco'}_${caminho}_${dono}`;
